<template>
  <div class="segment footer">
    <span style="margin-top:16px;"></span>
    <img src="@/assets/2026/berget-logo-26-2.png" />
    <span style="margin-top:32px;font-size: 17px;">Copyright Berget Events AB 2026. All rights reserved.</span>
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
.footer {
  background-color: #101010;
}
</style>
